<kilowant-header [isSeller]="true" title="Utilities"></kilowant-header>
<div class="form seller">
  <div class="card mt-20">
    <div class="body">
      <div class="block-buttons top-card mb-10">
        @if (user!=null) {
          <button type="button" (click)="addUtility()">+Add</button>
        }
      </div>
      <h2>Please select utilities which you serve</h2>
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows matSortActive="UtilityName" matSortDisableClear matSortDirection="asc" class="offer-summmary-table">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = dataIndex">{{i+1}}</td>
        </ng-container>
        <ng-container matColumnDef="UtilityId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility ID</th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <ng-container matColumnDef="State">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
          <td mat-cell *matCellDef="let element"> {{(element.state==null)?"-":element.state.name}} </td>
        </ng-container>
        <ng-container matColumnDef="UtilityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Utility Name</th>
          <td mat-cell *matCellDef="let element"> {{element.name}} </td>
        </ng-container>
        <ng-container matColumnDef="LoadZones">
          <th mat-header-cell *matHeaderCellDef>Load Zones</th>
          <td mat-cell *matCellDef="let element">
            @for (loadZone of element.loadZones; track loadZone) {
              <span>{{loadZone.name}}</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="RateClasses">
          <th mat-header-cell *matHeaderCellDef>Rate Classes</th>
          <td mat-cell *matCellDef="let element" class="short-list-view">
            @if (element.rateClasses.length > 0) {
              <span>{{element.rateClasses[0].name}}</span>
              @if (element.rateClasses.length > 1) {
                <span>{{element.rateClasses[1].name}}</span>
              }
              @if (element.rateClasses.length > 2) {
                <a class="viewMore" (click)="expandedElement = expandedElement === element ? null : element">More..</a>
              }
            }
          </td>
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" class="short-list-view" [attr.colspan]="displayedColumns.length">
              <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="expanded-block">
                  <i></i>
                  <b>Load Zones:</b><br />
                  @for (loadZone of element.loadZones; track loadZone; let x = $index) {
                    <span>{{loadZone.name}}</span>
                    }<br />
                    <b>Rate Classes:</b><br />
                    @for (rateclass of element.rateClasses; track rateclass; let x = $index) {
                      <span>{{rateclass.name}}</span>
                    }
                  </div>
                </div>
              </td>
            </ng-container>
          </ng-container>
          <ng-container matColumnDef="Action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element,let i = index">
              <a class="link f18" (click)="deleteUtility(element)">
                <mat-icon class="customIcons">delete_outline</mat-icon>
              </a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        </table>
        <mat-paginator class="b-none" [hidePageSize]="true" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
      </div>
    </div>
  </div>